import { Component, inject, computed, ChangeDetectionStrategy } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslatePipe, L10nTranslationModule } from 'angular-l10n';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FullPageLoadingService } from './full-page-loading.service';

@Component({
  selector: 'app-full-page-loading',
  standalone: true,
  imports: [L10nTranslationModule, L10nTranslatePipe, MatProgressBarModule, MatProgressSpinnerModule],
  templateUrl: './full-page-loading.component.html',
  styleUrl: './full-page-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullPageLoadingComponent {
  protected readonly locale = inject<L10nLocale>(L10N_LOCALE);
  private readonly loadingService = inject(FullPageLoadingService);

  private readonly loadingState = this.loadingService.state;

  protected readonly isVisible = computed<boolean>(() => {
    const state = this.loadingState();
    return state.isLoading;
  });

  protected readonly message = computed<string | undefined>(() => {
    const state = this.loadingState();
    return state.message;
  });

  protected readonly messageKey = computed<string | undefined>(() => {
    const state = this.loadingState();
    return state.messageKey;
  });

  protected readonly progress = computed<number | undefined>(() => {
    const state = this.loadingState();
    return state.progress;
  });

  protected readonly progressMode = computed<'determinate' | 'indeterminate'>(() => {
    return this.progress() !== undefined ? 'determinate' : 'indeterminate';
  });

  protected readonly progressValue = computed(() => {
    const prog = this.progress();
    return prog !== undefined ? Math.min(100, Math.max(0, prog)) : 0;
  });
}
